import http from '@/utils/http';
const base_path = '/v2/tool/advertiserSourceTemplate/batchCreateLog';

/**
 * 获取批量创建日志列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export function getBatchCreateLogListApi(params) {
  return http.get({
    url: base_path,
    params,
  });
}

/**
 * 获取批量创建日志详情接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export function getBatchCreateLogDetailApi(id) {
  return http.get({ url: `${base_path}/${id}` });
}
